module.exports = __webpack_public_path__ + "static/media/CLOSE.f3037977.svg";